import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MbFormErrorsComponent } from './mb-form-errors.component'
import { MbI18nModule } from '../../../translations/mb-i18n.module'

@NgModule({
  declarations: [
    MbFormErrorsComponent
  ],
  imports: [
    CommonModule,
    MbI18nModule
  ],
  exports: [
    MbFormErrorsComponent
  ]
})
export class MbFormErrorsModule { }
